/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';

import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import Form from '../../../common/Form';
import { form as FormStyle } from '../../../style/form';
import { isEmpty, deepObjectExtend } from '../../../utils/object';
import { combineStyle } from '../../../style/combineStyle';
import { DesktopTrackOrderStyle } from '../../../style/DesktopTrackOrderStyle';
import configENV from '../../../config';
import DesktopOrderByEmail from './DesktopOrderByEmail';
import DesktopOrderByZipCode from './DesktopOrderByZipCode';
import DesktopDeliveryHours from './DesktopDeliveryHours';
import DesktopSignInOrder from './DesktopSignInOrder';
import GraphqlSeoHeadTags from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

const { AUTH_LOGIN_URL, PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        FormStyle,
        DesktopTrackOrderStyle,
    }),
);

class DesktopTrackOrder extends Form {
    handleSignInClicked = () => {
        this.props.history.push(AUTH_LOGIN_URL);
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const {
            isReadyState, callBack, history, orderDetails, uuid, ROSSOrder,
        } = props;
        if (
            isReadyState
            && callBack
            && callBack.url
            && (orderDetails || ROSSOrder)
            && ((orderDetails && !isEmpty(orderDetails[uuid])) || (ROSSOrder && !isEmpty(ROSSOrder)))
            && callBack.url !== props.location.pathname
        ) {
            history.push(callBack.url);
        }
    };

    render() {
        /* eslint-disable max-len */
        const { isReadyState, classes, brand, featureFlags } = this.props;
        const seo = {
            page_title: (brand?.code === 'CAN' || brand?.code === 'PLA') ? `Track Order | ${brand?.code === 'CAN' ? '1800flowers.ca' : 'Plants.com'}` : 'Sign In',
            meta_description: '',
            location: { pathname: '/account/orders' },
        };

        return (
            <>
                <GraphqlSeoHeadTags seoData={seo} alternativeLang="true" />
                <div className={classes.DesktopTrackOrderStyle}>
                    {!['PLA', '08F', 'CAN'].includes(brand?.code)
                        && (
                            <>
                                <DesktopDeliveryHours classes={classes} />
                                <DesktopSignInOrder props={this.props} />
                                <div className="OR-dividerWrapper">
                                    <div className="OR-divider">or</div>
                                </div>
                            </>
                        )}
                    {brand?.code === 'PLA' ? <DesktopOrderByEmail isReadyState={isReadyState} featureFlags={featureFlags} /> : <DesktopOrderByZipCode isReadyState={isReadyState} featureFlags={featureFlags} />}
                </div>
            </>
        );
    }
}

DesktopTrackOrder.defaultProps = {
    handleSubmitOrderByZipCode: () => { },
    router: {},
};

DesktopTrackOrder.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    router: PropTypes.object,
    signInWithGoogle: PropTypes.func,
    handlePasswordlessLogin: PropTypes.func,
    brand: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        toggleState: newState.toggleState,
        callBack: newState.callBack,
        orderDetails: newState.orderDetails,
        uuid: newState.uuid,
        error: newState.error,
        ROSSOrder: newState.ROSSOrder,
        brand: getBrand(state),
        featureFlags: getFeatureFlags(state),
    };
};
const mapDispatchToProps = (dispatch) => ({
    handlePasswordlessLogin: () => dispatch(EventDispatcher.handlePasswordlessLogin()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(DesktopTrackOrder)));
